import { BUSINESS_DEFAULT_TAG_COLOR, BUSINESS_TAG_COLOR_PRESETS } from '@super-mega/server/contracts/business'
import { TagColorPicker, type TagColorPickerProps } from '@/components/tag-color-picker.tsx'

export function BusinessTagColorPicker(props: Pick<TagColorPickerProps, 'value' | 'onChange'>) {
  return <TagColorPicker {...props} defaultColor={BUSINESS_DEFAULT_TAG_COLOR} colors={BUSINESS_TAG_COLOR_PRESETS} />
}
